import {OrgUnit} from './orgUnit.model';

export class ClientEpisode {
    id: string;
    externalId: string;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    orgUnit: OrgUnit;

    constructor(clientEpisode: any) {
        if (clientEpisode) {
            this.id = clientEpisode.id;
            this.externalId = clientEpisode.externalId;
            this.name = clientEpisode.name;
            this.description = clientEpisode.description;
            this.startDate = clientEpisode.startDate;
            this.endDate = clientEpisode.endDate;
            this.orgUnit = new OrgUnit(clientEpisode.orgUnit);
        }
    }
}
